require('../../lib/js/angularmodule/JV.Core.Directives');
require('../../lib/ngStorage/ngStorage.min.js');
require('../../lib/select2/select2-3.4.5/select2.min.js');
require('../common/polyfills.js');
require('../common/directives/jv.AjaxSelect.js');
require('../common/directives/jv.Datepicker');
require('../common/directives/jv.Common.Directives.Focus');
require('../common/directives/jv.Select2');
require('../common/directives/jv.FormTemplate.webpack.js');
require('../common/directives/jv.MessageTemplate');
require('../common/directives/jv.Common.Directives.trunk8');
require('../common/jv.MessageBar');
require('../common/directives/jv.Tinymce.webpack.js');
require('../common/jv.Jobvite.Urls');
require('../common/jv.TemplateLoader');
require('../common/jv.Modal');
require('../common/jv.Loading');
require('../common/jv.i18n');
require('./jv.Candidates.List.Controller');
require('./jv.candidates.service');
require('./jv.candidates.factory');
require('./jv.candidate.modal.controller');
require('./jv.rejectCandidate.controller.js');
require('./details/jv.addToReq.controller');
require('../common/directives/expandy/jv.Expandy');
require('../common/directives/jv.Reset');
require('../../stylekit/js/jv.SortList.js');
var app = angular.module('jv.Candidates.List.app', [
    'ngRoute',
    'jv',
    'ngStorage',
    'JV.Core.Directives',
    'jv.Common.AjaxSelect',
    'jv.Common.Directives.Datepicker',
    'jv.services',
    'ngSanitize',
    'jv.Common.Directives.Select2',
    'jv.Common.Directives.Focus',
    'jv.Common.Modal',
    'jv.Common.Loading',
    'jv.Common.i18n',
    'jv.Common.Directives.trunk8',
    'jv.Common.MessageBar',
    'jv.Common.Directives.Formtemplate',
    'jv.Common.Directives.MessageTemplate',
    'jv.Common.Jobvite.Urls',
    'jv.candidates.list.controller',
    'jv.candidates.service',
    'jv.Common.TemplateLoader',
    'jv.candidates.list.controller',
    'jv.candidates.list.factory',
    'jv.candidate.modal.controller',
    'jv.rejectCandidate.controller',
    'jv.addToReq.controller',
    'jv.Common.Directives.Reset',
    'jv.Common.Directives.Expandy',
    'jv.Common.Directives.SortList'
]);

app.value('modalTemplateUrl', '../../htm/common/modal.html');
app.value('messageBarTemplateUrl', '../../htm/common/messageBar.html');
